import colors from 'vuetify/util/colors';
import { AppColors } from '@/themes/theme';

export const adosaColors: Partial<AppColors> = {
  systemPrimary: '#333333',
  systemSecondary: '#fefefe',
  buttonPrimary: '#d4106e',
  primary: colors.indigo.darken3,
  buttonWarning: '#FF0000',
  buttonConfirm: colors.green.darken2,
  buttonDefault: colors.grey.darken1,
  rdpbackground: '#FFFFFF',
  leftpanelhover: '#333333',
};
